import { render } from "./MyApps.vue?vue&type=template&id=d0d3df52&ts=true"
import script from "./MyApps.vue?vue&type=script&lang=ts"
export * from "./MyApps.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__